import React, { memo, useCallback, useState } from 'react'
import { IActionsOverlayProps } from './types'
import * as Styled from './styled'
import ContextMenu from 'common-components/ContextMenu'
import { PrimaryActions } from './PrimaryActions'

const ActionsOverlay: React.FC<IActionsOverlayProps> = (
  props: IActionsOverlayProps
) => {
  const { className, actions, scrollableElementRef, contextMenuPosition } =
    props

  const { mainAction, primaryActions, secondaryActions } = actions
  const [isContextMenuVisible, setIsContextMenuVisible] = useState(false)

  const handleToggle = useCallback(() => {
    setIsContextMenuVisible(prev => !prev)
  }, [])

  const handleClose = useCallback(() => {
    setIsContextMenuVisible(false)
  }, [])

  const handleActionsContainerClick = useCallback((event: React.MouseEvent) => {
    event.stopPropagation()
  }, [])

  return (
    <Styled.ActionsOverlayWrapper
      className={className}
      $isVisible={isContextMenuVisible}
    >
      <Styled.ActionsContainer onClick={handleActionsContainerClick}>
        <PrimaryActions actionsData={primaryActions} />
        {secondaryActions && (
          <ContextMenu
            actions={secondaryActions}
            scrollableElementRef={scrollableElementRef}
            onToggle={handleToggle}
            onClose={handleClose}
            size={contextMenuPosition?.togglerSize}
            flyoutOptions={contextMenuPosition?.flyoutOptions}
            isMobileWithDrawer={contextMenuPosition?.isMobileWithDrawer}
            showMobileBackButton={contextMenuPosition?.showMobileBackButton}
          />
        )}
      </Styled.ActionsContainer>
      {mainAction && <Styled.MainActionTrigger onClick={mainAction} />}
    </Styled.ActionsOverlayWrapper>
  )
}

export default memo(ActionsOverlay)
